'use client'
import { useState } from 'react'
import { useRouter, useSearchParams } from 'next/navigation'
import styles from './style.module.scss'

export default function SearchForm() {
  const router = useRouter()
  const searchParams = useSearchParams()
  // URLにすでにクエリがある場合は初期値にする
  const defaultQuery = searchParams.get('q') || ''
  const [query, setQuery] = useState(defaultQuery)

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (!query.trim()) return

    // 検索ページへ遷移
    router.push(`/search?q=${encodeURIComponent(query)}`)
  }
  return (
    <div className={styles.container}>
      <form onSubmit={handleSubmit} className={styles.searchForm}>
        <label>
          <input
            type="text"
            placeholder="記事を検索"
            value={query}
            onChange={(e) => {
              setQuery(e.target.value)
            }}
          />
        </label>
        <button type="submit" className={styles.searchButton}>
          検索
        </button>
      </form>
    </div>
  )
}
